import React, { useState } from "react"
import { Helmet } from "react-helmet"
import tw, { css, styled } from "twin.macro"
import Checkbox from "./checkbox"

const Input = styled.input(({ error }) => [
  tw`font-sans mb-2 p-2 focus:outline-none text-black rounded w-full placeholder-gray-800 border-2 border-transparent focus:border-brand-yellow`,
  error && tw`border-red-600`,
])

const SubmitButton = styled.button`
  ${tw`font-licenz bg-brand-yellow rounded text-black px-4 py-1 uppercase hover:text-black hover:bg-white focus:outline-none border border-2 border-transparent focus:border-white mt-3 disabled:bg-gray-400`}
`


const CMForm: React.FC = () => {
  const [completedSecondary, setCompletedSecondary] = useState<boolean>(false)

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/imk8sgg.css" />
        <script
          type="text/javascript"
          src="https://js.createsend1.com/javascript/copypastesubscribeformlogic.js"
        />
      </Helmet>

      <form
        className="js-cm-form"
        css={[tw`w-full`]}
        id="subForm"
        action="https://www.createsend.com/t/subscribeerror?description="
        method="post"
        data-id="A61C50BEC994754B1D79C5819EC1255C81B9557809087A60B03347F921E3EAC176D3F5C302C68C4B7DA465E8197D9EDF97E7E3B4656FFB49B8F98BD8987B2564"
      >
        <div>
          <div>
            <Input
              aria-label="First name"
              id="fieldtuktdtr"
              maxLength={200}
              name="cm-f-tuktdtr"
              required={true}
              placeholder="First name"
              autoComplete="given-name"
            />
          </div>
          <div>
            <Input
              aria-label="Last name"
              id="fieldtuktdty"
              maxLength={200}
              name="cm-f-tuktdty"
              required={true}
              placeholder="Last name"
              autoComplete="family-name"
            />
          </div>
          <div>
            <Input
              autoComplete="Email"
              aria-label="Email"
              className="js-cm-email-input qa-input-email"
              id="fieldEmail"
              maxLength={200}
              name="cm-jtltihr-jtltihr"
              required={true}
              type="email"
              placeholder="Email"
            />
          </div>
        </div>
        <div css={tw`mt-4`}>
          <label css={[tw`flex flex-row font-sans text-sm cursor-pointer`]}>
            <Checkbox
              required
              checked={completedSecondary}
              onChange={(e: any) => {
                setCompletedSecondary(e.target.checked)
              }}
            />
            I confirm I am at least 16 years old and no longer at school
          </label>
        </div>
        <div css={[tw`flex flex-col items-center justify-center`]}>
          <SubmitButton type="submit" disabled={!completedSecondary}>SEND</SubmitButton>
        </div>

        <div css={[tw`flex flex-col justify-center w-full mt-2 md:mt-8`]}>
          <a
            css={[tw`font-sans text-sm text-gray-400 underline text-center`]}
            href="https://www.mito.org.nz/privacy-and-copyright/"
            target="_blank"
          >
            Privacy statement
          </a>
        </div>
      </form>
    </>
  )
}

export default CMForm
